const moduleAddress={
    state: {
        choosedaddress:{}
    },
    mutations: {
        SET_ADDRESS:(state,payload)=>{
            state.choosedaddress=payload.address
        },
        INIT_ADDRESS:(state)=>{
            state.choosedaddress={}
        }
    },
    actions: {
        
    }
}

export default moduleAddress